<template><!-- svgo-optimised -->
<svg class="icon icon__plus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M7.493 6v1.493H4.507v1.014h2.986v2.986h1.014V8.507h2.986V7.493H8.507V4.507H7.493V6" fill="currentColor" fill-rule="evenodd"/></svg>
</template>